import { AnaHazardId } from "@/store/services/facades/types";
import type { Icon } from "@phosphor-icons/react";
import {
  DropIcon,
  FireIcon,
  HurricaneIcon,
  ImageBrokenIcon,
  MountainsIcon,
  PersonSimpleSwimIcon,
  SnowflakeIcon,
  ThermometerHotIcon,
  TornadoIcon,
  WavesIcon,
  WindIcon,
} from "@phosphor-icons/react/dist/ssr";
import { anaHazards } from "../../lib/crg_apis/constants/hazards";

// Kept out of `types.ts` so `tailwind.report.config.js` can read the colours without the rest of branding.
export const hazardMeta = {
  coastal_inundation: { icon: WavesIcon, color: "#2563EB" },
  cyclone_wind: { icon: TornadoIcon, color: "#F97316" },
  cyclone_storm_surge: { icon: HurricaneIcon, color: "#10B981" },
  flood_riverine: { icon: DropIcon, color: "#0EA5E9" },
  flood_surfacewater: { icon: PersonSimpleSwimIcon, color: "#8B5CF6" },
  forest_fire: { icon: FireIcon, color: "#E11D48" },
  freeze_thaw: { icon: SnowflakeIcon, color: "#06B6D4" },
  heat: { icon: ThermometerHotIcon, color: "#EC4899" },
  landslide: { icon: MountainsIcon, color: "#84CC16" },
  soil_movement: { icon: ImageBrokenIcon, color: "#F59E0B" },
  wind: { icon: WindIcon, color: "#01224c" },
} satisfies Record<AnaHazardId, { icon: Icon; color: string }>;

export const getHazardName = (hazardId: AnaHazardId | "total"): string => {
  return hazardId === "total" ? "All Hazards" : (anaHazards[hazardId]?.name ?? hazardId);
};
